import { MutableRefObject, Ref, RefCallback, useEffect, useRef } from 'react';

type CombinedRef<T> = Ref<T> | MutableRefObject<T | null>;

export function useCombinedRefs<T>(
  ...refs: CombinedRef<T>[]
): MutableRefObject<T | null> {
  const targetRef = useRef<T | null>(null);

  useEffect(() => {
    for (const ref of refs) {
      if (!ref) {
        continue;
      }

      if (typeof ref === 'function') {
        (ref as RefCallback<T | null>)(targetRef.current);
      } else if ('current' in ref) {
        (ref as MutableRefObject<T | null>).current = targetRef.current;
      }
    }
  }, [refs]);

  return targetRef;
}
